import Icon from '../components/Icon.vue'

Icon.register({
  'grip-lines-vertical': {
    width: 256,
    height: 512,
    paths: [
      {
        d: 'M96 496V16C96 7.2 88.8 0 80 0H48C39.2 0 32 7.2 32 16V496C32 504.8 39.2 512 48 512H80C88.8 512 96 504.8 96 496zM224 496V16C224 7.2 216.8 0 208 0H176C167.2 0 160 7.2 160 16V496C160 504.8 167.2 512 176 512H208C216.8 512 224 504.8 224 496z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/grip-lines-vertical.js
// module id = mSKe
// module chunks = 144